export const configSatelliteDhGlobalIrht = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/WNI_ANLSIS_SAT_WORLD_CLDTOP/list",
      "cache_busting": true
    },
    "region": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/WNI_ANLSIS_SAT_WORLD_CLDTOP/region_area",
      "update_interval": 0
    },
    "data": {
      "Type": "TMS",
      "Name": "WNI_ANLSIS_SAT_WORLD_CLDTOP",
      "url": "%expo_tile_sat_url%/WNI_ANLSIS_SAT_WORLD_CLDTOP_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configSatelliteDhGlobalIrtp = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/WNI_ANLSIS_SAT_WORLD_IR/list",
      "cache_busting": true
    },
    "region": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/WNI_ANLSIS_SAT_WORLD_IR/region_area",
      "update_interval": 0
    },
    "data": {
      "Type": "TMS",
      "Name": "WNI_ANLSIS_SAT_WORLD_IR",
      "url": "%expo_tile_sat_url%/WNI_ANLSIS_SAT_WORLD_IR_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const configSatelliteDhGlobalWv = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/WNI_ANLSIS_SAT_WORLD_WV/list",
      "cache_busting": true
    },
    "region": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/WNI_ANLSIS_SAT_WORLD_WV/region_area",
      "update_interval": 0
    },
    "data": {
      "Type": "TMS",
      "Name": "WNI_ANLSIS_SAT_WORLD_WV",
      "url": "%expo_tile_sat_url%/WNI_ANLSIS_SAT_WORLD_WV_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};


export const configSatelliteLayerGlobalIrht = {
  "Name": "SatelliteGlobalIRHT",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "palette": [
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 0],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 168],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [128, 128, 128, 214],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153]
        ]
      },
      "monochrome": {
        "type": "grayscale_palette",
        "palette": [
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 3],
          [255, 255, 255, 6],
          [255, 255, 255, 9],
          [255, 255, 255, 13],
          [255, 255, 255, 16],
          [255, 255, 255, 19],
          [255, 255, 255, 23],
          [255, 255, 255, 26],
          [255, 255, 255, 29],
          [255, 255, 255, 33],
          [255, 255, 255, 36],
          [255, 255, 255, 39],
          [255, 255, 255, 43],
          [255, 255, 255, 46],
          [255, 255, 255, 49],
          [255, 255, 255, 53],
          [255, 255, 255, 56],
          [255, 255, 255, 59],
          [255, 255, 255, 63],
          [255, 255, 255, 66],
          [255, 255, 255, 69],
          [255, 255, 255, 73],
          [255, 255, 255, 76],
          [255, 255, 255, 79],
          [255, 255, 255, 83],
          [255, 255, 255, 86],
          [255, 255, 255, 89],
          [255, 255, 255, 92],
          [255, 255, 255, 96],
          [255, 255, 255, 99],
          [255, 255, 255, 102],
          [255, 255, 255, 106],
          [255, 255, 255, 109],
          [255, 255, 255, 112],
          [255, 255, 255, 116],
          [255, 255, 255, 119],
          [255, 255, 255, 122],
          [255, 255, 255, 126],
          [255, 255, 255, 129],
          [255, 255, 255, 132],
          [255, 255, 255, 136],
          [255, 255, 255, 139],
          [255, 255, 255, 142],
          [255, 255, 255, 146],
          [255, 255, 255, 149],
          [255, 255, 255, 152],
          [255, 255, 255, 156],
          [255, 255, 255, 159],
          [255, 255, 255, 162],
          [255, 255, 255, 166],
          [255, 255, 255, 169],
          [255, 255, 255, 172],
          [255, 255, 255, 175],
          [255, 255, 255, 179],
          [255, 255, 255, 182],
          [255, 255, 255, 185],
          [255, 255, 255, 189],
          [255, 255, 255, 192],
          [255, 255, 255, 195],
          [255, 255, 255, 199],
          [255, 255, 255, 202],
          [255, 255, 255, 205],
          [255, 255, 255, 209],
          [255, 255, 255, 212],
          [255, 255, 255, 215],
          [255, 255, 255, 219],
          [255, 255, 255, 222],
          [255, 255, 255, 225],
          [255, 255, 255, 229],
          [255, 255, 255, 232],
          [255, 255, 255, 235],
          [255, 255, 255, 239],
          [255, 255, 255, 242],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 255]
        ]
      }
    }
  }
};

export const configSatelliteLayerGlobalIrtp = {
  "Name": "SatelliteGlobalIRTP",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "palette": [
          [0, 0, 0, 0],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 17],
          [255, 255, 255, 17],
          [255, 255, 255, 25],
          [255, 255, 255, 25],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 42],
          [255, 255, 255, 42],
          [255, 255, 255, 42],
          [255, 255, 255, 42],
          [255, 255, 255, 42],
          [255, 255, 255, 51],
          [255, 255, 255, 51],
          [255, 255, 255, 51],
          [255, 255, 255, 51],
          [255, 255, 255, 51],
          [255, 255, 255, 51],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153]
        ]
      },
      "monochrome": {
        "type": "grayscale_palette",
        "palette": [
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 2],
          [255, 255, 255, 5],
          [255, 255, 255, 7],
          [255, 255, 255, 10],
          [255, 255, 255, 13],
          [255, 255, 255, 15],
          [255, 255, 255, 18],
          [255, 255, 255, 20],
          [255, 255, 255, 23],
          [255, 255, 255, 26],
          [255, 255, 255, 28],
          [255, 255, 255, 31],
          [255, 255, 255, 34],
          [255, 255, 255, 36],
          [255, 255, 255, 39],
          [255, 255, 255, 41],
          [255, 255, 255, 44],
          [255, 255, 255, 47],
          [255, 255, 255, 49],
          [255, 255, 255, 52],
          [255, 255, 255, 55],
          [255, 255, 255, 57],
          [255, 255, 255, 60],
          [255, 255, 255, 62],
          [255, 255, 255, 65],
          [255, 255, 255, 68],
          [255, 255, 255, 70],
          [255, 255, 255, 73],
          [255, 255, 255, 76],
          [255, 255, 255, 78],
          [255, 255, 255, 81],
          [255, 255, 255, 83],
          [255, 255, 255, 86],
          [255, 255, 255, 89],
          [255, 255, 255, 91],
          [255, 255, 255, 94],
          [255, 255, 255, 96],
          [255, 255, 255, 99],
          [255, 255, 255, 102],
          [255, 255, 255, 104],
          [255, 255, 255, 107],
          [255, 255, 255, 110],
          [255, 255, 255, 112],
          [255, 255, 255, 115],
          [255, 255, 255, 117],
          [255, 255, 255, 120],
          [255, 255, 255, 123],
          [255, 255, 255, 125],
          [255, 255, 255, 128],
          [255, 255, 255, 131],
          [255, 255, 255, 133],
          [255, 255, 255, 136],
          [255, 255, 255, 138],
          [255, 255, 255, 141],
          [255, 255, 255, 144],
          [255, 255, 255, 146],
          [255, 255, 255, 149],
          [255, 255, 255, 152],
          [255, 255, 255, 154],
          [255, 255, 255, 157],
          [255, 255, 255, 159],
          [255, 255, 255, 162],
          [255, 255, 255, 165],
          [255, 255, 255, 167],
          [255, 255, 255, 170],
          [255, 255, 255, 172],
          [255, 255, 255, 175],
          [255, 255, 255, 178],
          [255, 255, 255, 180],
          [255, 255, 255, 183],
          [255, 255, 255, 186],
          [255, 255, 255, 188],
          [255, 255, 255, 191],
          [255, 255, 255, 193],
          [255, 255, 255, 196],
          [255, 255, 255, 199],
          [255, 255, 255, 201],
          [255, 255, 255, 204],
          [255, 255, 255, 207],
          [255, 255, 255, 209],
          [255, 255, 255, 212],
          [255, 255, 255, 214],
          [255, 255, 255, 217],
          [255, 255, 255, 220],
          [255, 255, 255, 222],
          [255, 255, 255, 225],
          [255, 255, 255, 228],
          [255, 255, 255, 230],
          [255, 255, 255, 233],
          [255, 255, 255, 235],
          [255, 255, 255, 238],
          [255, 255, 255, 241],
          [255, 255, 255, 243],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 254],
          [255, 255, 255, 255]
        ]
      }
    }
  }
};

export const configSatelliteLayerGlobalWv = {
  "Name": "SatelliteWv",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "palette": [
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [255, 255, 255, 40],
          [255, 255, 255, 42],
          [255, 255, 255, 44],
          [255, 255, 255, 47],
          [255, 255, 255, 49],
          [255, 255, 255, 52],
          [255, 255, 255, 54],
          [255, 255, 255, 57],
          [255, 255, 255, 59],
          [255, 255, 255, 61],
          [255, 255, 255, 64],
          [255, 255, 255, 66],
          [255, 255, 255, 69],
          [255, 255, 255, 71],
          [255, 255, 255, 74],
          [255, 255, 255, 76],
          [255, 255, 255, 79],
          [255, 255, 255, 81],
          [255, 255, 255, 83],
          [255, 255, 255, 86],
          [255, 255, 255, 88],
          [255, 255, 255, 91],
          [255, 255, 255, 93],
          [255, 255, 255, 96],
          [255, 255, 255, 98],
          [255, 255, 255, 101],
          [255, 255, 255, 103],
          [255, 255, 255, 105],
          [255, 255, 255, 108],
          [255, 255, 255, 110],
          [255, 255, 255, 113],
          [255, 255, 255, 115],
          [255, 255, 255, 118],
          [255, 255, 255, 120],
          [255, 255, 255, 123],
          [255, 255, 255, 125],
          [255, 255, 255, 127],
          [255, 255, 255, 130],
          [255, 255, 255, 132],
          [255, 255, 255, 135],
          [255, 255, 255, 137],
          [255, 255, 255, 140],
          [255, 255, 255, 142],
          [255, 255, 255, 145],
          [255, 255, 255, 147],
          [255, 255, 255, 149],
          [255, 255, 255, 152],
          [255, 255, 255, 154],
          [255, 255, 255, 157],
          [255, 255, 255, 159],
          [255, 255, 255, 162],
          [255, 255, 255, 164],
          [255, 255, 255, 166],
          [255, 255, 255, 169],
          [255, 255, 255, 171],
          [255, 255, 255, 174],
          [255, 255, 255, 176],
          [255, 255, 255, 179],
          [255, 255, 255, 181],
          [255, 255, 255, 184],
          [255, 255, 255, 186],
          [255, 255, 255, 188],
          [255, 255, 255, 191],
          [255, 255, 255, 193],
          [255, 255, 255, 196],
          [255, 255, 255, 198],
          [255, 255, 255, 201],
          [255, 255, 255, 203],
          [255, 255, 255, 206],
          [255, 255, 255, 208],
          [255, 255, 255, 210],
          [255, 255, 255, 213],
          [255, 255, 255, 215],
          [255, 255, 255, 218],
          [255, 255, 255, 220],
          [255, 255, 255, 223],
          [255, 255, 255, 225],
          [255, 255, 255, 228],
          [255, 255, 255, 230],
          [255, 255, 255, 232],
          [255, 255, 255, 235],
          [255, 255, 255, 237],
          [255, 255, 255, 240],
          [255, 255, 255, 242],
          [255, 255, 255, 245],
          [255, 255, 255, 247],
          [255, 255, 255, 250],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255]
        ]
      }
    }
  }
};
